import { isLibraryInOut } from '@festina/configuration-general-types/configuration'
import { useCallback } from 'react'

import { useApplicationViewOperationsContext } from '../workspace/applicationViewOperationsContext'

/**
 * Returns `true` if the template with `templateId` belongs to a library.
 */
export const useTemplateIsLibrary = () => {
  const { applicationTemplates } = useApplicationViewOperationsContext()
  return useCallback(
    (templateId: string) =>
      isLibraryInOut(applicationTemplates.get(templateId)?.lastEntity),
    [applicationTemplates],
  )
}
